const Resources = {

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Change Password',
            href:   '/profile-change-password',
            arrow:  "",
        },
    ],

}

export default Resources;